import { render } from "./CompanyIntro.vue?vue&type=template&id=01007b07&scoped=true"
import script from "./CompanyIntro.vue?vue&type=script&lang=js"
export * from "./CompanyIntro.vue?vue&type=script&lang=js"

import "./CompanyIntro.vue?vue&type=style&index=0&id=01007b07&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01007b07"]])

export default __exports__